// extracted by mini-css-extract-plugin
module.exports = {"framework-selector":"H_c3 d-flex","framework-selector__icon":"H_c4","framework-selector__option":"H_c5 p-2 flex-grow-1 ml-2","framework-selector__option--selected":"H_c6"};